<template>

  <v-container fluid v-if="policies">

    <im-page-title
      title="Politici de anulare"
    />

    <im-policies-tool
      @create="goToCreate()"
    />

    <im-policies-list
      :policies="policies"
      @edit="goToEdit($event)"
      @list="getPolicies($event)"
    />

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>


<script>

  import policy_repository from '@/repositories/policy-repository';

  export default {
    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-policies-tool': () => import('@/components/PolicyCancellation/CancellationPolicyToolbar'),
      'im-policies-list': () => import('@/components/PolicyCancellation/CancellationPolicyList')
    },

    data: () => ({
      policies: null
    }),

    async created() {
      this.policies = await this.getPolicies({size: 10, page: 1});
    },

    methods: {
      async getPolicies(pagination) {
        return policy_repository.getCancellationPolicies(this.$route.params.hotel, pagination);
      },

      goToCreate() {
        const h_id = this.$route.params.hotel;
        this.$router.push(`/hotels/${h_id}/cancellation-policies/create`);
      },

      goToEdit(policy) {
        const h_id = this.$route.params.hotel;
        const p_id = policy.id;
        this.$router.push(`/hotels/${h_id}/cancellation-policies/${p_id}`);
      }
    }
  }

</script>